export default __webpack_public_path__ + "static/SectionGeometry-90f358d64e2c38d913844e4d2a90052b.svg";